<template>
  <v-form v-model="valid" ref="indicatorFieldForm">
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex xs12>
          <v-text-field @input="sync" label="Название поля (РУС)" required v-model="object.title_ru" :counter="255" :rules="rules.title_ru" />
        </v-flex>
        <v-flex xs12>
          <v-text-field @input="sync" label="Название поля (КАЗ)" required v-model="object.title_kz" :counter="255" :rules="rules.title_kz" />
        </v-flex>
        <v-flex xs12>
          <v-select @input="sync" label="Тип поля" @change="fillDefaultTitle()" required v-model="object.type" :items="fieldTypesOptions" item-value="code" item-text="title" :rules="rules.type" />
        </v-flex>
        <template xs12 v-if="object.type === 'enum'">
          <v-flex xs12>
            <h5>Значения списка:</h5>
          </v-flex>
          <v-flex xs12 v-for="(item, index) in object.enums" :key="object.id + ':enums:' + index">
            <v-form>
              <v-container>
                <v-layout wrap>
                  <v-flex xs6>
                    <v-text-field @input="sync" label="Значение элемента (РУС)" v-model="item.value_ru" />
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field @input="sync" label="Значение элемента (КАЗ)" v-model="item.value_kz" />
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field @input="sync" label="Дополнение к баллам" v-model="item.award" append-outer-icon="delete" @click:append-outer="delEnumItem(index)" />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-flex>
          <v-flex xs12 text-xs-right>
            <v-btn flat icon><v-icon color="primary" @click="addEnumItem()">library_add</v-icon></v-btn>
          </v-flex>
        </template>
        <v-flex xs6>
          <v-switch @input="sync" label="Обязательное поле" v-model="object.required" />
        </v-flex>
        <v-flex xs6>
          <v-switch @input="sync" label="Отображать в списке результатов" v-model="object.listed" />
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'

// import { sortBySequence } from '@/plugins/helpers'

import { IndicatorField, IndicatorFieldEnum } from '@/api/indicators'

export default {
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    model: {
      type: IndicatorField,
      required: true,
    },
    reinit: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    valid: false,
    object: new IndicatorField(),
    rules: {
      title_ru: [
        v => !!v || 'Обязательное поле',
        v => (v && v.length <= 255) || 'Максимум 255 символов',
      ],
      title_kz: [
        v => !!v || 'Обязательное поле',
        v => (v && v.length <= 255) || 'Максимум 255 символов',
      ],
      type: [
        v => !!v || 'Обязательное поле',
      ],
    },
  }),
  computed: {
    ...mapState('indicators', {
      fieldTypes: (state) => state.fieldTypes
    }),
    fieldTypesOptions () {
      return Object.keys(this.fieldTypes).map((type) => {
        return {
          code: type,
          title: this.fieldTypes[type]
        }
      })
    }
  },
  watch: {
    valid () {
      this.$emit('on-validate', this.valid)
    },
    reinit (val) {
      if (val) {
        this.init()
      }
    }
  },
  mounted () {},
  methods: {
    fillDefaultTitle () {
      if (this.object.type === 'award' && !this.object.title_ru && !this.object.title_kz) {
        this.object.title_ru = 'Значение';
        this.object.title_kz = 'Значение';
      }
    },
    addEnumItem () {
      this.object.enums.push(new IndicatorFieldEnum())
    },
    delEnumItem (index) {
      this.object.enums.splice(index, 1)
    },

    init () {
      this.$refs.indicatorFieldForm.resetValidation()
      this.object = new IndicatorField(this.model)
    },
    sync () {
      this.$emit('change', this.object)
    }
  },
}
</script>
